import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-mail.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollTarget"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/analytics/components/ScrollTarget.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageLayout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageViewLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AutoupdateBanner"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/components/AudoupdateBanner/AutoupdateBanner.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/components/AutoupdateAdvantages/AutoupdateAdvantages.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AutoupdateFAQ"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/components/AutoupdateFAQ/AutoupdateFAQ.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/components/AutoupdateInstruction/AutoupdateInstruction.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/components/AutoupdateRequirements/AutoupdateRequirements.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/Autoupdate.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["IntroBanner"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/Autoupdate/components/IntroBanner/IntroBanner.tsx");
